<template>
  <div class="dropDownBox" :style="{'width':width+'px'}">
    <slot name="body" />
  </div>
</template>

<script>
export default {
  name: 'DropDownBoxIndex',
  props: {
    width: {
      type: String,
      default: '500'
    },
    height: {
      type: String,
      default: '500'
    },
    left: {
      type: String,
      default: '25%'
    },
    top: {
      type: String,
      default: '25%'
    }
  },
  data() {
    return {

    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      const keyframes = `@keyframes mymove {100% {height: ${this.height}px;}}`
      // 创建style标签
      const style = document.createElement('style')
      // 设置style属性
      style.type = 'text/css'
      // 将 keyframes样式写入style内
      style.innerHTML = keyframes
      // 将style样式存放到box标签
      document.getElementsByClassName('dropDownBox')[0].appendChild(style)
    }
  }
}
</script>

<style lang="scss" scoped>
.dropDownBox{
    height: 0px;
    z-index: auto;
    overflow: hidden;
    animation: mymove 0.5s 1;
    animation-fill-mode:forwards  ;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px rgba(37, 44, 54, 0.25);
}
// @keyframes mymove {50% {height: 500px;}}
</style>
